import React, { useContext } from 'react'
import { QuestionRow } from './QuestionRow/QuestionRow';

const RemoveVehicleConfirm = ({ policyStateAbbr, vehReqContext, vehicleContext, reqVehicleClass }) => {
    const context = useContext(vehReqContext);
    const deleteVehicleContext = useContext(vehicleContext);
    var removedVehicle = deleteVehicleContext?.deleteVehicle

    return (
        <>
            {/* Confirm these questions' answer */}
            <QuestionRow
                reqVehicleContext={vehicleContext}
                requestType="Remove Vehicle"
                name="removedVehicle"
                question="Removed Vehicle"
            />
            <span className='fw-bold text-dark' style={{ paddingLeft: '3px' }}>
                {`${removedVehicle?.Year} ${removedVehicle?.Make} ${removedVehicle?.Model} - ${removedVehicle?.VIN}`}
            </span>

            <QuestionRow
                reqVehicleContext={vehicleContext}
                requestType="Remove Vehicle"
                name="requestedRemovalEffDate"
                question="Requested Remove Vehicle Effective Date*"
            />

            <QuestionRow
                reqVehicleContext={vehicleContext}
                requestType="Remove Vehicle"
                name="vehicleRemovalReason"
                question="What is the primary reason for removing this vehicle?*"
            />

            {removedVehicle?.vehicleRemovalExplanation != "" &&
                <QuestionRow
                    reqVehicleContext={vehicleContext}
                    requestType="Remove Vehicle"
                    name="vehicleRemovalExplanation"
                    question="Please explain..."
                />
            }
        </>
    )
}

export default RemoveVehicleConfirm